import { computed, ref } from "vue";

// tiposNotas tiene que se un ref o reactive que contenga el listado de tipos de nota
export function useTipoNotaActual(tiposNotas) {
  // Este campo está en otra parte de la pantalla y no se gestiona con Vue, así que
  // tenemos que capturar el campo a mano directamente del DOM
  const idTipoNotaActual = document.getElementById('selector_tipo_nota').value;
  const tipoNotaActual = computed(() => {
    return tiposNotas.value.find((tn) => tn.id.toString() === idTipoNotaActual.toString());
  });
  
  return {
    tipoNotaActual,
  };
}
